import React from 'react'
import styles from './Global.module.css'

function Spinner() {
  return (
    <span className={`${styles.loader} ${styles.loader_lg}`}> </span>
  )
}

export default Spinner